import * as coreCommon from 'assets/core/js/common'
import ImagesSlider from 'assets/core/js/module/images-slider'
import readMoreText from 'assets/core/js/module/read-more-text'

const initPropertiesSliders = function (): void {
  document.querySelectorAll<HTMLElement>('.aquatic__wrapper .slider:not(.slider-initialized)').forEach(function (el) {
    ImagesSlider(el, {
      loop: true,
      navigation: {
        nextEl: el.querySelector<HTMLElement>('.slider-button-next'),
        prevEl: el.querySelector<HTMLElement>('.slider-button-prev'),
      },
      pagination: {
        el: el.querySelector<HTMLElement>('.slider-pagination'),
        type: 'custom',
        renderCustom: function (current: number) {
          return `${current}/${el.querySelectorAll('.slide').length}`
        },
      },
      spaceBetween: 16,
    })
  })

  document.querySelectorAll<HTMLElement>('.product__properties-slider .slider:not(.slider-initialized)').forEach(function (el) {
    ImagesSlider(el, {
      loop: true,
      navigation: {
        nextEl: el.querySelector<HTMLElement>('.slider-button-next'),
        prevEl: el.querySelector<HTMLElement>('.slider-button-prev'),
      },
      pagination: {
        el: el.querySelector<HTMLElement>('.slider-pagination'),
        type: 'custom',
        renderCustom: function (current: number, total: number) {
          return `${current}/${total}`
        },
      },
      spaceBetween: 16,
    })
  })
}

document.querySelectorAll<HTMLElement>('.product__section .dca-collapsible-block__toggle[data-url]').forEach(function (el) {
  el.addEventListener(
    'click',
    function (this: HTMLElement) {
      const url = this.getAttribute('data-url')

      if (!url) {
        return
      }

      const sectionEl = this.closest('.product__section')

      if (!sectionEl) {
        return
      }

      const toggleEl = sectionEl.querySelector(`.dca-collapsible-block__content[data-toggle="${this.getAttribute('data-target')}"]`)

      if (!toggleEl) {
        return
      }

      const xhrRequest = coreCommon.createXhr('GET', url)

      xhrRequest.onreadystatechange = () => {
        if (xhrRequest.readyState === XMLHttpRequest.DONE && xhrRequest.status === 200 && xhrRequest.response) {
          toggleEl.innerHTML = xhrRequest.response as string
          readMoreText(sectionEl)
          initPropertiesSliders()
          this.removeAttribute('data-url')
        }
      }

      xhrRequest.send()
    },
    {
      once: true,
    }
  )
})

export default function (): void {
  initPropertiesSliders()
}
